/**
 * Lazy Components - Code Splitting Implementation
 * Implements lazy loading for heavy components to optimize bundle size
 */

import { lazy } from 'react';

// Core pages
export const LazyDashboard = lazy(() =>
  import('@/components/Dashboard').then(module => ({
    default: module.Dashboard
  }))
);
export const LazyProjects = lazy(() =>
  import('@/components/Projects').then(module => ({
    default: module.Projects
  }))
);
export const LazyWorkflowStages = lazy(() =>
  import('@/components/WorkflowStages').then(module => ({
    default: module.WorkflowStages
  }))
);
export const LazyAdministration = lazy(() =>
  import('@/pages/new/Administration').then(module => ({
    default: module.default
  }))
);
export const LazyContextAnalytics = lazy(() =>
  import('@/pages/new/ContextAnalytics').then(module => ({
    default: module.default
  }))
);
export const LazySystemRecommendations = lazy(() =>
  import('@/pages/new/SystemRecommendations').then(module => ({
    default: module.default
  }))
);
export const LazyCostUsage = lazy(() =>
  import('@/pages/new/CostUsage').then(module => ({
    default: module.default
  }))
);
export const LazyUsageEfficiency = lazy(() =>
  import('@/pages/new/UsageEfficiency').then(module => ({
    default: module.default
  }))
);
export const LazyProgramPgm = lazy(() =>
  import('@/pages/new/ProgramPgm').then(module => ({
    default: module.default
  }))
);
export const LazyReleaseWorkspace = lazy(() =>
  import('@/pages/new/ReleaseWorkspace').then(module => ({
    default: module.default
  }))
);
export const LazyDiscoveryPage = lazy(() =>
  import('@/pages/new/DiscoveryPage').then(module => ({
    default: module.default
  }))
);
export const LazyControlTower = lazy(() =>
  import('@/pages/new/ControlTower').then(module => ({
    default: module.default
  }))
);
export const LazyStageModal = lazy(() =>
  import('@/components/StageModal').then(module => ({
    default: module.StageModal
  }))
);

// Admin pages
export const LazyConfig = lazy(() =>
  import('@/pages/admin/Config').then(module => ({
    default: module.default
  }))
);
export const LazyRepos = lazy(() =>
  import('@/pages/admin/Repos').then(module => ({
    default: module.default
  }))
);
export const LazyCacheManagement = lazy(() =>
  import('@/pages/admin/CacheManagement').then(module => ({
    default: module.default
  }))
);
export const LazyRepositorySyncStatus = lazy(() =>
  import('@/components/admin/RepositorySyncStatus').then(module => ({
    default: module.default
  }))
);
export const LazyAudit = lazy(() =>
  import('@/pages/admin/Audit').then(module => ({
    default: module.default
  }))
);
export const LazyActors = lazy(() =>
  import('@/pages/admin/Actors').then(module => ({
    default: module.default
  }))
);
export const LazySkills = lazy(() =>
  import('@/pages/admin/Skills').then(module => ({
    default: module.default
  }))
);
export const LazyInterventions = lazy(() =>
  import('@/pages/Interventions').then(module => ({
    default: module.default
  }))
);
export const LazyWorkflows = lazy(() =>
  import('@/pages/admin/Workflows').then(module => ({
    default: module.default
  }))
);
